import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_game_matrix_display = _resolveComponent("game-matrix-display")!
  const _component_game_wrapper = _resolveComponent("game-wrapper")!

  return (_openBlock(), _createBlock(_component_game_wrapper, {
    title: "Order Matters",
    name: "OrderMatters",
    "is-game-over": _ctx.isGameOver,
    counter: _ctx.restartCounter,
    "score-elements": _ctx.scoreElements,
    "action-buttons": _ctx.currentActionButtons,
    instruction: _ctx.currentInstruction,
    onSubmitMatrix: _ctx.submitMatrix,
    onPrecountdownOver: _ctx.startShowTimer,
    onRestart: _ctx.restart
  }, {
    default: _withCtx(() => [
      _createVNode(_component_game_matrix_display, {
        class: "memory-matrix__game-matrix",
        matrix: _ctx.currentMatrix,
        "spaced-items": true,
        "max-width": _ctx.maxMatrixDisplayWidth,
        onItemClick: _ctx.handleItemClick
      }, null, 8, ["matrix", "max-width", "onItemClick"])
    ]),
    _: 1
  }, 8, ["is-game-over", "counter", "score-elements", "action-buttons", "instruction", "onSubmitMatrix", "onPrecountdownOver", "onRestart"]))
}